import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'floating-vue/dist/style.css';
import isMobile from 'ismobilejs';
import getParams from '@/utility/getParams';
import EventBus from '@nsftx/games-sdk-js/src/utility/eventBus';

store.state.isAndroid = isMobile().android.device;
store.commit('SET_PARAMS', getParams());
const isNextGen = store.getters.queryParametars.get('platform') === 'NextGen';
store.state.isNextGen = isNextGen;
const parent = store.getters.queryParametars.get('parent');
const nextGenStandaloneIntegration = typeof parent !== 'undefined' && parent === 'false';
let AuthorizationChanged = null;
let firstLoadBalanceChange = false;

const addUser = () => {
  store.state.firstLoadUserAuthorisation = true;
  store.dispatch('handleSocketMessage', {
    eventName: AuthorizationChanged.data.action,
    data: AuthorizationChanged.data.data,
  });
  EventBus.$off('configReady');
  AuthorizationChanged = null;
}
let productName = store.getters.queryParametars.get('productName');
const productNamePrefixes = ['SRMV', 'NVNV', 'NSNV'];
for (const productPrefix of productNamePrefixes) {
  if (productName.startsWith(productPrefix)) productName = productName.slice(productPrefix.length);
}
store.state.productName = productName;

window.addEventListener('message', (event) => {
  if (event.data?.action === 'Slave.Load') {
    store.state.currency = event.data.data.user.currency;
    store.state.showCursor = event.data.data?.settings?.showCursor;
    store.dispatch('handleSocketMessage', {
      eventName: event.data.action,
      data: event.data.data,
    });
  }
  if (isNextGen) {
    EventBus.$on('configReady', () => {
      if (!store.state.firstLoadUserAuthorisation && AuthorizationChanged) {
        addUser();
      }
    });
    if (event.data?.action === 'User.AuthorizationChanged' && !store.state.firstLoadUserAuthorisation) {
      AuthorizationChanged = event;
      if (!store.state.firstLoadUserAuthorisation && store.state.config) {
        addUser();
      }
    }
    if (event.data?.action === 'User.BalanceChanged' && !firstLoadBalanceChange) {
      firstLoadBalanceChange = true;
      setTimeout((e) => {
        store.state.firstLoadUserAuthorisation = true;
        store.dispatch('handleSocketMessage', {
          eventName: e.data.action,
          data: e.data.data,
        });
      }, 1000, event);
    }
  }
});
window.addEventListener('Bus:Message', (event) => {
  store.dispatch('handleSocketMessage', event.detail);
});
window.addEventListener('Configuration:SetConfiguration', (e) => {
  const detail = e.detail;
  store.state.gatewayConfigurationDetails = detail;
  store.state.isIntegration = detail.isIntegration;
  store.state.moneyDenominations = detail.moneyDenominations;
  store.state.scrollButtons = detail.scrollButtons?.value;
  store.state.showCursor = detail?.showCursor;
  store.dispatch('gamesBetslip/setBetslipBlockers', {
    blockers: detail.betslip?.blockers || [],
    type: detail.betslip?.blockers.length ? 'add' : 'remove',
  });
  window.nextGenConfig = detail;
  if (isNextGen) {
    store.dispatch('setNextGenStandaloneIntegration', nextGenStandaloneIntegration);
  }
});
if (store.getters.layoutTerminal) {
  window.addEventListener('offline', () => {
    store.dispatch('setInternetConnection', false);
  });
  window.addEventListener('online', () => {
    store.dispatch('setInternetConnection', true);
    // EventBus.$emit('getNewEvents');
  });
}

createApp(App).use(router).use(store).mount('#app');
